import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';



@Component({
    selector: 'app-mobile-map',
    templateUrl: './mobile-map.component.html',
    styleUrls: ['./mobile-map.component.css'],
    standalone: false
})
export class MobileMapComponent implements OnInit {

  map: Map;
  constructor() {
  }
  ngOnInit(): void {
   
  }
}
